import { SectorModel } from './../../service/sector.model';
import { DBConnectorService } from './../../service/test.service';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const apiEndPoint = "api/TrainExisting/Step3Done";

@Component({
  selector: 'app-step3-done',
  templateUrl: './step3-done.component.html',
  styleUrls: ['./step3-done.component.css', '../../../../node_modules/nvd3/build/nv.d3.css']
})
export class Step3DoneComponent implements OnInit {

  sectormodel = new SectorModel;
  options;
  data;
  months;
  total_records = 0
  total_categories = 0
  public result_data:any = {};
  urldata: any = {};
  accuracyOverviews;
  getcommandjson:any = {}

  constructor(private testService: DBConnectorService, 
    private http: HttpClient) {

    this.sectormodel.SectorName = this.testService.SectorName;
    this.sectormodel.ModelName = this.testService.ModelName;
   
  }
  
  graphFunction() {
    this.http.get(apiEndPoint + "?Sector=" + this.sectormodel.SectorName + "&Model=" + this.sectormodel.ModelName)
      
      .subscribe((result) => {
        //console.log("home.component.ts: line 385: JSON.stringify(result) " + JSON.stringify(result));
        this.urldata = result;
        //console.log("home.component.ts: line 385: JSON.stringify(this.urldata) " + JSON.stringify(this.urldata));

        let slice_top_limit = 10;
        this.accuracyOverviews = result["accuracyOverview"];//.slice(1, slice_top_limit);
        //console.log("home.component.ts: line 37 : accuracyOverviews " + this.accuracyOverviews);
        let values1 = []
        let values2 = []
        for (let entry of this.accuracyOverviews) {

          this.total_categories += 1;
          let labelValue = {}
          labelValue["x"] = entry.category;
          labelValue["y"] = +entry.recordsPredicted;
          this.total_records += +entry.recordsPredicted;

          values1.push(labelValue);

          labelValue = {}
          labelValue["x"] = entry.category;
          labelValue["y"] = +entry.recordsNotPredicted;
          this.total_records += +entry.recordsNotPredicted;
          values2.push(labelValue);
        }

        let _array = []
        let _dict = {}
        _dict["key"] = "Accurate Predictions";
        _dict["color"] = "#00a3ae";
        _dict["values"] = values1;
        _array.push(_dict)

        _dict = {}
        _dict["key"] = "Wrong Predictions";
        _dict["color"] = "#7fd1d6";
        _dict["values"] = values2;
        _array.push(_dict)

        //console.log("home.component.ts: line 419: _array " + JSON.stringify(_array));
        this.data = _array;

        this.options = {
          "chart": {
            "type": "multiBarChart",
            "height": 450,
            "margin": {
              "top": 40,
              "right": 20,
              "bottom": 100,
              "left": 45
            },
            "reduceXTicks": false,
            "clipEdge": true,
            "duration": 500,
            "stacked": true,
            "xAxis": {
              "rotateLabels": -30,
              "showMaxMin": false
            },
            "yAxis": {

              "axisLabelDistance": -20
            }
          }
        };


      }
    );
  }

  ngOnInit() {
    this.graphFunction();
  }

}
